import React from 'react'
import { Box, Chip, Typography } from '@material-ui/core'
import { TrendingUp as TrendingUpIcon } from 'react-feather'

import constants from 'constants/index'
import useStyles from './styles'

const TemplateStatsCard = ({ summary, template, averageRate }) => {
  const classes = useStyles()

  const clicked = summary?.clicked ?? 0
  const delivered = summary?.delivered ?? 0

  const clickRate =
    delivered > 0 ? ((clicked / delivered) * 100).toFixed(1) : null

  const aboveAverage =
    clickRate !== null && averageRate !== undefined
      ? parseFloat((parseFloat(clickRate) - averageRate).toFixed(0))
      : null

  const difficultyKey = (template?.difficulty || '').toLowerCase()
  const difficulty = constants.phishing.DIFFICULTY_MAP[difficultyKey] || null

  return (
    <Box className={classes.root}>
      <Box className={classes.statCard}>
        <Typography className={classes.statLabel}>
          Taxa de clique no link
        </Typography>

        <Box className={classes.clickRateRow}>
          <Typography className={classes.clickRate}>
            {clickRate !== null ? `${clickRate}%` : '—'}
          </Typography>

          {aboveAverage !== null && (
            <Chip
              icon={<TrendingUpIcon size={12} />}
              label={`${
                aboveAverage > 0 ? '+' : ''
              }${aboveAverage}% acima da média`}
              size="small"
              className={classes.averageChip}
            />
          )}
        </Box>

        <Typography className={classes.clickSubtitle}>
          {clicked} de {delivered} participantes clicaram no link
        </Typography>
      </Box>

      {template?.platform && (
        <Box className={classes.statCard}>
          <Typography className={classes.statLabel}>
            Plataforma simulada
          </Typography>
          <Typography className={classes.statValue}>
            {template.platform}
          </Typography>
        </Box>
      )}

      {difficulty && (
        <Box className={classes.statCard}>
          <Typography className={classes.statLabel}>Dificuldade</Typography>
          <Box mt={0.5}>
            <Chip
              label={difficulty.label}
              size="small"
              className={classes.difficultyChip}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default TemplateStatsCard
